import React from 'react'
import AddressForm from '../Components/Address/AddressForm'


const AddNewAddress = () => {
    return <AddressForm />
}
export default AddNewAddress
